import React from 'react';
import {
  StatusPanel,
  StatusIcon,
  StatusBody,
  StatusHeading,
  StatusMessage,
} from '../styles';

const CompletedView: React.FC = () => {
  return (
    <StatusPanel $kind="success">
      <StatusIcon aria-hidden>{'\u2713'}</StatusIcon>
      <StatusBody>
        <StatusHeading>Biometria concluída</StatusHeading>
        <StatusMessage>
          Sua validação de biometria foi concluída com sucesso! Seu cadastro para
          recebimento de comissões na Pagarme foi ativado.
        </StatusMessage>
      </StatusBody>
    </StatusPanel>
  );
};

export default CompletedView;
